import { render, staticRenderFns } from "./BlockTagRow.vue?vue&type=template&id=56e4f1f5&scoped=true&"
import script from "./BlockTagRow.vue?vue&type=script&lang=ts&"
export * from "./BlockTagRow.vue?vue&type=script&lang=ts&"
import style0 from "./BlockTagRow.vue?vue&type=style&index=0&id=56e4f1f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4f1f5",
  null
  
)

export default component.exports